import {
  collection,
  doc,
  addDoc,
  getDocs,
  getDoc,
  updateDoc,
  query,
  where,
  orderBy,
  serverTimestamp,
  increment,
} from 'firebase/firestore'
import { db } from '@/services/firebase/config'
import type { Review } from '@/types/review'

const REVIEWS_COLLECTION = 'reviews'

export async function createReview(
  reviewerId: string,
  reviewerName: string,
  sellerId: string,
  rating: number,
  comment: string,
  listingId?: string
): Promise<string> {
  const docRef = await addDoc(collection(db, REVIEWS_COLLECTION), {
    reviewerId,
    reviewerName,
    sellerId,
    listingId: listingId || null,
    rating,
    comment,
    createdAt: serverTimestamp(),
  })

  // Update seller's average rating
  try {
    const sellerRef = doc(db, 'users', sellerId)
    const sellerDoc = await getDoc(sellerRef)
    if (sellerDoc.exists()) {
      const data = sellerDoc.data()
      const currentRating = data.rating || 0
      const currentCount = data.reviewCount || 0
      const newCount = currentCount + 1
      const newRating = (currentRating * currentCount + rating) / newCount

      await updateDoc(sellerRef, {
        rating: Math.round(newRating * 10) / 10,
        reviewCount: increment(1),
        updatedAt: serverTimestamp(),
      })
    }
  } catch (error) {
    console.error('Error updating seller rating:', error)
  }

  return docRef.id
}

export async function getReviewsForSeller(sellerId: string): Promise<Review[]> {
  const q = query(
    collection(db, REVIEWS_COLLECTION),
    where('sellerId', '==', sellerId),
    orderBy('createdAt', 'desc')
  )
  const snapshot = await getDocs(q)
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() })) as Review[]
}

export async function getReviewForTransaction(
  reviewerId: string,
  listingId: string
): Promise<Review | null> {
  const q = query(
    collection(db, REVIEWS_COLLECTION),
    where('reviewerId', '==', reviewerId),
    where('listingId', '==', listingId)
  )
  const snapshot = await getDocs(q)
  if (snapshot.empty) return null
  return { id: snapshot.docs[0].id, ...snapshot.docs[0].data() } as Review
}
